export default __webpack_public_path__ + "static/media/563.45206691.png";